export default __webpack_public_path__ + "static/media/P.7a0f0171.svg";